module.exports = __webpack_public_path__ + "media/images/carousel-arow-8f26b6c2.svg";